import isEmpty from "./isEmpty";
const R_VALID_CHARS = /^(\d|\(|\)|\s|-)*$/;
const R_NON_DIGITS = /[^0-9]/g;
export default function validPhone(value) {
    return isEmpty(value) || (R_VALID_CHARS.test(value) && value.replace(R_NON_DIGITS, "").length === 10);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/validPhone.ts